/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";

// Define the Thank You Component
const ThankYouPage = () => {
  // Inline styles for simplicity
  const styles = {
    container: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "20px",
      backgroundColor: "#ffffff",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
    },
    heading: {
      color: "#4CAF50",
    },
    button: {
      display: "inline-block",
      padding: "10px 20px",
      margin: "20px 0",
      backgroundColor: "#4CAF50",
      color: "white",
      textDecoration: "none",
      borderRadius: "5px",
    },
    buttonHover: {
      backgroundColor: "#45a049",
    },
    supportSection: {
      marginTop: "20px",
      borderTop: "1px solid #ddd",
      paddingTop: "20px",
    },
    supportLink: {
      color: "#007BFF",
      textDecoration: "none",
    },
  };

  // Render the component
  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={styles.container}>
        <h1 style={styles.heading}>Thank You for Your Purchase!</h1>
        <p>Hello,</p>
        <p>
          Thank you for purchasing the <strong>Frayo</strong>{" "}
          subscription. We are excited to have you on board!
        </p>

        {/* Product Access / Download Link */}
        <h2>How to Access Your Product</h2>
        <p>You can access your product using the link below:</p>
        <a href={process.env.REACT_APP_WEB_URL} style={styles.button}>
          Access Frayo
        </a>
        <p>
          <em>
            Please use the credentials provided during registration to log in.
          </em>
        </p>

        {/* Additional Instructions (if any) */}
        <h2>Getting Started</h2>
        <p>
          If this is your first time accessing the product, please follow the
          instructions below:
        </p>
        <ol>
          <li>Click the "Access Frayo" button above.</li>
          <li>
            Log in with the email and password you used during registration.
          </li>
          <li>
            Navigate to the <strong>Settings</strong> page to view and manage
            your subscription.
          </li>
        </ol>

        {/* Product Information / Extra Content */}
        <h2>Product Information</h2>
        <p>
          For more information on how to get the most out of Frayo, please
          visit our{" "}
          <a
            href={`${process.env.REACT_APP_WEB_URL}/sales-page`}
            style={styles.supportLink}
          >
            Help Center
          </a>{" "}
        </p>

        {/* Support and Contact Information */}
        <div style={styles.supportSection}>
          <h2>Need Help?</h2>
          <p>
            If you encounter any issues or have questions, please don't hesitate
            to reach out to our support team:
          </p>
          <p>
            Email:{" "}
            <a href="mailto:support@frayo.net" style={styles.supportLink}>
              support@frayo.net
            </a>
          </p>
     
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
